import { useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
// hooks
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
// prime react
import { Button } from "primereact/button";
// components
import Select from "../../../components/input/Select";
import NumberInput from "../../../components/input/NumberInput";
import CalendarInput from "../../../components/input/CalendarInput";
// utils
import { formatYearDate } from "../../../utils/formatDate";
//services
import { getCostCenter } from "../../../services/CostCenter/getCostCenter";
import { postInstallment } from "../../../services/Financial/postInstallment";
import TextareaInput from "../../../components/input/TextareaInput";
import { getParcelDescription } from "../../../services/GlobalRoles/getParcelDescription";
import { useAppContext } from "../../../context/AppContext";

export const AccountForm = ({ closeModal }) => {
  const { permissions } = useAppContext();
  const [loading, setLoading] = useState(false);

  const form = useForm();
  const errors = form.formState.errors;

  const { client, isLoadingClients, enterprise, isLoadingEnterprises } =
    useOptionsSelect();

  const { data: costCenter, isLoading: isLoadingCost } = useQuery({
    queryKey: ["cost-center"],
    queryFn: () => getCostCenter(),
    retry: false,
    enabled: !!permissions?.includes("116")
  });

  //Buscar descrição de Parcelas
  const { data: parcelsDescription, isLoading: isLoadingDesc } = useQuery({
    queryKey: ["parcelDescription"],
    queryFn: () => getParcelDescription(),
    enabled: !!permissions?.includes("140")
  });


  function hasSubcategories(ref, costCenter) {
    return costCenter.some((item) => item.ref.startsWith(ref + "."));
  }
  
  const processedOptions = costCenter
    ? costCenter
        .filter((dado) => dado.ref.startsWith("1")) // Apenas ref que começam com "1"
        .sort((a, b) => (a.ref < b.ref ? -1 : a.ref > b.ref ? 1 : 0))
        .filter((dado) => !hasSubcategories(dado.ref, costCenter)) // Filtra os pais
        .map((dado) => ({
          value: dado.id,
          label: `${dado.ref} - ${dado.desc}`,
        }))
    : [];
  
  
  const itemTemplate = (option) => {
    return (
      <div
        style={{
          color: option.isDisabled ? 'gray' : 'black',
          pointerEvents: option.isDisabled ? 'none' : 'auto',
          opacity: option.isDisabled ? 0.5 : 1
        }}
      >
        {option.label}
      </div>
    );
  };

  async function onSubmit(data) {
    setLoading(true);
    const notification = toast.loading("Adicionando..");

    data.date = formatYearDate(data.date);

    try {
      const response = await postInstallment(data);

      //      console.log(response);

      toast.update(notification, {
        render: response.success,
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });

      closeModal();
      form.reset();
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="row px-3">
          <div className="col-md-4 mb-3">
            <Select
              name="payer_id"
              label={isLoadingClients ? "Carregando..." : "Cliente"}
              control={form.control}
              isRequired={true}
              disabled={isLoadingClients}
              options={client}
              errors={errors}
            />
          </div>
          <div className="col-md-4 mb-3">
            <Select
              name="cost_center_id"
              label={isLoadingCost ? "Carregando..." : "Centro de Custo"}
              control={form.control}
              isRequired={true}
              disabled={isLoadingCost}
              options={processedOptions}
              itemTemplate={itemTemplate}
              errors={errors}
            />
          </div>
          <div className="col-md-4 mb-3">
            <Select
              className="w-100"
              optionLabel="description"
              label={isLoadingDesc ? "Carregando..." : "Descrição"}
              disabled={isLoadingDesc}
              isRequired={true}
              optionValue="id"
              control={form.control}
              options={parcelsDescription || []}
              name="installment_description_id"
            />
          </div>
          <div className="col-md-4 mb-3">
            <NumberInput
              min={0}
              control={form.control}
              name="value"
              className="w-100"
              errors={errors}
              required={true}
              label="Valor da parcela"
              mode="currency"
              currency="BRL"
              locale="pt-BR"
              useGrouping={true}
              minFractionDigits={2}
              maxFractionDigits={2}
            />
          </div>

          <div className="col-md-4 mb-3">
            <NumberInput
              min={0}
              control={form.control}
              name="amount"
              className="w-100"
              required={true}
              errors={errors}
              max={400}
              label="Qtd de parcelas"
            />
          </div>
          <div className="col-md-4 mb-3">
            <Select
              name="enterprise_id"
              isRequired={true}
              control={form.control}
              label={isLoadingEnterprises ? "Carregando..." : "Empreendimento*"}
              disabled={isLoadingEnterprises}
              options={enterprise}
              errors={errors}
            />
          </div>
          <div className="col-md-4 mb-3">
            <CalendarInput
              name="date"
              isRequired={true}
              control={form.control}
              errors={errors}
              label="Data 1º Parc."
            />
          </div>
          <div className="col-md-12 mt-3">
            <TextareaInput
              name="obs"
              isRequired={true}
              label="Observação"
              errors={errors}
              control={form.control}
            />
          </div>
          <div className="mt-4 text-centerÏ">
            <Button
              rounded
              type="submit"
              label="Cadastrar"
              loading={loading}
              icon="fa fa-plus"
              className="p-inputtext-sm m-auto"
            />
          </div>
        </div>
      </form>
    </>
  );
};
